import { apiInstance, gql } from "@/services/httpAdapter";

export async function getUserPayPlansHistory(id: string, locationId: string) {
	const query = gql`
		query getUser($_id: String!, $locationId: String!) {
			getUser(_id: $_id, locationId: $locationId) {
				_id
				currentPayPlanAssignment {
					locationId
					position
					assignmentDate
					acknowledgementDate
					acknowledgementDocumentLink
					effectiveDate
					planId {
						_id
						name
					}
					acknowledgementStatus {
						status
						statusDate
						signingProgress {
							roleId
							signedAt
						}
					}
					embeddedSigningLinks {
						url
						role
					}
				}
				payPlanAssignmentHistory {
					locationId
					position
					assignmentDate
					acknowledgementDate
					acknowledgementDocumentLink
					effectiveDate
					planId {
						_id
						name
					}
					acknowledgementStatus {
						status
						statusDate
						signingProgress {
							roleId
							signedAt
						}
					}
					embeddedSigningLinks {
						url
						role
					}
				}
				upcomingPayPlanAssignment {
					locationId
					position
					assignmentDate
					acknowledgementDate
					acknowledgementDocumentLink
					effectiveDate
					planId {
						_id
						name
						pdfAvailability
					}
					acknowledgementStatus {
						status
						statusDate
						signingProgress {
							roleId
							signedAt
						}
					}
					embeddedSigningLinks {
						url
						role
					}
				}
			}
		}
	`;

	const variables = {
		_id: id,
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUser;
	} catch (err) {
		console.log(err);
	}

	return null;
}

export async function getUsersPayPlanAssignment(locationId: string, position: string[] | null = null, status: string | null = null) {
	const query = gql`
		query getUsers($locationId: String!, $filter: UserFilterInput) {
			getUsers(locationId: $locationId, filter: $filter) {
				_id
				locationId
				position
				fullName
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			locationId,
			position,
			status,
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUsers || [];
	} catch (err) {
		console.log(err);
	}

	return [];
}

export async function getUserPayPlanAssignmentPage(id: string, locationId: string) {
	const query = gql`
		query getUser($_id: String!, $locationId: String!) {
			getUser(_id: $_id, locationId: $locationId) {
				_id
				locationId
				employeeId
				fullName
				position
				communications {
					acceptsTxt
					communicationType
					usage
					value
				}
				upcomingPayPlanAssignment {
					_id
					acknowledgementDate
					acknowledgementDocumentLink
					auditEvidenceLink
					assignedBy
					assignmentDate
					planId {
						_id
						name
						position
						pdfAvailability
					}
					effectiveDate
					position
					acknowledgementStatus {
						status
						statusDate
						signingProgress {
							fullName
							roleId
							signedAt
						}
					}
					packageId
				}
				currentPayPlanAssignment {
					_id
					acknowledgementDate
					acknowledgementDocumentLink
					auditEvidenceLink
					assignedBy
					assignmentDate
					effectiveDate
					planId {
						_id
						name
						position
					}
					position
					acknowledgementStatus {
						status
						statusDate
					}
				}
				payPlanAssignmentHistory {
					_id
					acknowledgementDate
					acknowledgementDocumentLink
					auditEvidenceLink
					assignedBy
					assignmentDate
					locationId
					effectiveDate
					planId {
						_id
						name
						position
					}
					position
					acknowledgementStatus {
						status
						statusDate
					}
				}
				supervisor {
					_id
					fullName
				}
				hireDate
				isDepartmental
			}
		}
	`;

	const variables = {
		_id: id,
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUser || null;
	} catch (err) {
		console.log(err);
	}

	return null;
}

export async function getUsersByPositionGroupPayPlanAssignment(locationId: string, position: string, status: string) {
	const query = gql`
		query getUsers($locationId: String!, $filter: UserFilterInput) {
			getUsers(locationId: $locationId, filter: $filter) {
				_id
				fullName
				position
				upcomingPayPlanAssignment {
					acknowledgementDate
					acknowledgementDocumentLink
					assignmentDate
					planId {
						_id
						name
					}
				}
				currentPayPlanAssignment {
					acknowledgementDate
					acknowledgementDocumentLink
					assignmentDate
					planId {
						_id
						name
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			locationId,
			position,
			status,
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUsers || [];
	} catch (err) {
		console.log(err);
	}

	return [];
}

export async function getUsersByPositionHistoryPayPlanAssignment(locationId: string, position: string[], payPlanId: string) {
	const query = gql`
		query getUsers($locationId: String!, $filter: UserFilterInput) {
			getUsers(locationId: $locationId, filter: $filter) {
				_id
				fullName
				position
				employeeId
				locationId
				profilePicture
				upcomingPayPlanAssignment {
					_id
					packageId
					acknowledgementDate
					acknowledgementDocumentLink
					acknowledgementStatus {
						status
						statusDate
						signingProgress {
							fullName
							roleId
							signedAt
						}
					}
					assignedBy
					assignmentDate
					planId {
						_id
						name
						position
					}
					effectiveDate
					position
				}
				payPlanAssignmentHistory {
					_id
					acknowledgementDate
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					acknowledgementStatus {
						status
						statusDate
					}
					effectiveDate
					planId {
						_id
						name
						position
					}
					position
				}
				communications {
					acceptsTxt
					communicationType
					usage
					value
				}
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			locationId,
			position,
			payPlanAssignmentHistory: [payPlanId],
			upcomingPayPlanAssignment: [payPlanId],
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUsers || [];
	} catch (err) {
		console.log(err);
	}

	return [];
}
